import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { BalancePage } from "../pages/BalancePage";
import { storage } from "../lib/storage";

export const Route = createFileRoute("/balance")({
  head: () => ({
    meta: [{ title: "Hisob — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  beforeLoad: () => {
    if (typeof window !== "undefined" && !storage.getItem("auth_token")) {
      throw redirect({ to: "/" });
    }
  },
  component: Balance,
});

function Balance() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <BalancePage />
    </LangProvider>
  );
}
